import type { ArticleCard } from 'types/capi/shared';

import ArticleHighlightCarousel from './ArticleHighlightCarousel';
import Duo from './Duo';
import Feature from './Feature';
import Headlines from './Headlines';
import Highlights from './Highlights';
import Tiles from './Tiles';

export type ArticlesSectionLayout =
  | 'duo'
  | 'carousel'
  | 'feature'
  | 'headlines'
  | 'highlights'
  | 'tiles';

type Props =
  | {
      items: ArticleCard[];
      layout: 'headlines' | 'highlights' | 'duo' | 'tiles' | 'carousel';
    }
  | { article: ArticleCard; layout: 'feature' };

export default function ArticlesSection(props: Props) {
  switch (props.layout) {
    case 'duo':
      return <Duo items={props.items} />;
    case 'carousel':
      return <ArticleHighlightCarousel items={props.items} />;
    case 'feature':
      return <Feature article={props.article} />;
    case 'headlines':
      return <Headlines items={props.items} />;
    case 'highlights':
      return <Highlights items={props.items} />;
    case 'tiles':
      return <Tiles items={props.items} />;
    default:
      return null;
  }
}
